import { HbrOption, HbrSelect } from '@harbor/elements-react-standalone';
import React from 'react';

/**
 * Initial use case: opp stage name
 * column template displays an adjusted string
 * We're hard-coding select options to avoid confusion
 *
 * Add a column id and custom controls for filter value where needed
 *
 * Eventually we want most of the columns to automatically use search-selects
 * that contain all unique column values as options.
 */

const columnOverrides = {
  StageName: [
    '0 - Target',
    '1 - Qualify',
    '1- Qualify',
    '1 - Qualify\u200b',
    '1-Prospect',
    '2 - Propose',
    '3 - Technical Validation',
    '4 - Business Validation',
    '4-Selection',
    '5 - Negotiate',
    '6 - Closed Won',
    'Identified',
  ],

  SE_Status__c: [
    'No SE Assigned',
    'No SE Required',
    'SE Completed',
    'SE Work in Progress',
    'Technical Close',
    'Technical On-Hold',
  ],

  se_phase: [
    'discovery',
    'present',
    'design',
    'validate',
    'tech_close',
  ]
};

const valueControlOverride = (
  columnId: string,
  operatorType: string,
  handler,
  value: string | string[]
): React.ReactNode | null => {
  if (Object.keys(columnOverrides).includes(columnId)) {
    return (
      <HbrSelect
        placeholder='Select value'
        onHbr-change={(evt) => handler(evt.target.value)}
        variant={operatorType === 'multi' ? 'tag' : 'single'}
        clearable={operatorType === 'multi'}
        value={value}
        className="capitalize"
      >
        {columnOverrides[columnId].map((option) => (
          <HbrOption key={option} value={option} className="capitalize">
            {option.replace(/_/g, ' ')}
          </HbrOption>
        ))}
      </HbrSelect>
    );
  }
  return null;
};

export { valueControlOverride };
